import { Injectable } from "@angular/core";
import { DataService } from "../../core/services/data.service";
import { LaboratoryDashboardDataset } from "../models/dashboards/laboratory/laboratory-dashboard-dataset";
import { HttpClient } from "@angular/common/http";
import { NotificationService } from "../../core/services/notification.service";
import { Observable } from "rxjs";

@Injectable()
export class DashboardsService extends DataService<LaboratoryDashboardDataset, LaboratoryDashboardDataset> {

    constructor(http: HttpClient, notificationService: NotificationService) {
        super(http, notificationService);
        this.controllerName = 'dashboards';
    }

    getLaboratoryDashboard(): Observable<LaboratoryDashboardDataset> {
        return this.getQuery<LaboratoryDashboardDataset>(`${this.baseUrl()}/laboratory`);
    }
}